import MedicationAnswer from "../abstract/MedicationAnswer"
import BoolQuestionAnswerStrategy from "../abstract/BoolQuestionAnswerStrategy"
import MedicationQuestion from "../abstract/MedicationQuestion"
import QuestionCreator from "../abstract/QuestionCreator"

const PatientTakesAtLeastNumberOfAntidepressants =
    (
        count: number,
        answer: MedicationAnswer,
        optional: {
            strategy: BoolQuestionAnswerStrategy
            followedBy?: MedicationQuestion
        } = { strategy: BoolQuestionAnswerStrategy.ON_YES }
    ): QuestionCreator =>
    (input) =>
        new MedicationQuestion(
            `Nimmt die Patient:in mindestens ${String(count)} Antidepressiva?`,
            input
        ).answerAutomatically((input) => {
            if (input.medication.length >= count) {
                return optional.strategy === BoolQuestionAnswerStrategy.ON_YES
                    ? answer
                    : new MedicationAnswer("Ja")
            }
            return optional.strategy === BoolQuestionAnswerStrategy.ON_NO
                ? answer
                : new MedicationAnswer("Nein")
        })

export default PatientTakesAtLeastNumberOfAntidepressants